(function () {
  var bar = document.getElementById('gk-humidity-bar');
  var popup = document.getElementById('gk-humidity-popup');
  var configEl = document.getElementById('gk-humidity-config');

  if (!bar || !popup || !configEl) return;

  var config = JSON.parse(configEl.textContent);
  var cacheKey = 'gk_humidity_weather_v10';
  var weatherData = null;
  var currentTier = null;
  var barDismissed = false;

  // Clear any older dismiss flags so the banner can show again.
  clearLegacyDismiss();

  function clearLegacyDismiss() {
    var keys = ['gk_humidity_banner_dismissed', 'gk_humidity_banner_dismissed_v2'];
    for (var i = 0; i < keys.length; i++) {
      try {
        if (window.localStorage) localStorage.removeItem(keys[i]);
      } catch (e) {}
      try {
        if (window.sessionStorage) sessionStorage.removeItem(keys[i]);
      } catch (e) {}
      try {
        document.cookie =
          keys[i] + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
      } catch (e) {}
    }
  }

  function isBarDismissed() {
    return barDismissed;
  }

  function hideBar() {
    bar.classList.remove('is-visible');
    bar.setAttribute('hidden', '');
    bar.style.display = 'none';
    bar.style.visibility = 'hidden';
  }

  function dismissBar() {
    barDismissed = true;
    hideBar();
    closePopup();
  }

  if (popup.parentNode !== document.body) document.body.appendChild(popup);
  if (bar.parentNode !== document.body) document.body.appendChild(bar);

  bindEvents();

  // Show cached weather immediately, then always refresh location/humidity.
  var cached = sessionStorage.getItem(cacheKey);
  if (cached) {
    try {
      initWeather(JSON.parse(cached));
    } catch (e) {
      sessionStorage.removeItem(cacheKey);
    }
  }
  loadWeather();

  function normalizeGeo(geo) {
    if (!geo) return null;

    var city =
      geo.city ||
      geo.city_name ||
      geo.regionName ||
      geo.region ||
      '';
    var latitude = geo.latitude != null ? geo.latitude : geo.lat;
    var longitude = geo.longitude != null ? geo.longitude : geo.lon;
    var region = geo.region_code || geo.region || geo.regionName || '';
    var countryCode = geo.country_code || geo.countryCode || geo.country || '';

    if (!city || latitude == null || longitude == null) return null;
    if (geo.success === false) return null;

    return {
      city: String(city).trim(),
      region: String(region || '').trim(),
      countryCode: String(countryCode || '').trim(),
      latitude: latitude,
      longitude: longitude
    };
  }

  function fetchHumidity(latitude, longitude) {
    var url =
      'https://api.open-meteo.com/v1/forecast?latitude=' +
      latitude +
      '&longitude=' +
      longitude +
      '&current=relative_humidity_2m';

    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (w) {
        if (!w.current || w.current.relative_humidity_2m == null) {
          throw new Error('weather failed');
        }
        return w.current.relative_humidity_2m;
      });
  }

  function fetchGeoFromIpWho() {
    return fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (geo) {
        var normalized = normalizeGeo(geo);
        if (!normalized) throw new Error('ipwho failed');
        return normalized;
      });
  }

  function fetchGeoFromIpApi() {
    return fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (geo) {
        var normalized = normalizeGeo(geo);
        if (!normalized) throw new Error('ipapi failed');
        return normalized;
      });
  }

  function loadWeather() {
    fetchGeoFromIpWho()
      .catch(function () {
        return fetchGeoFromIpApi();
      })
      .then(function (geo) {
        return fetchHumidity(geo.latitude, geo.longitude).then(function (humidity) {
          return {
            city: geo.city,
            region: geo.region,
            countryCode: geo.countryCode,
            humidity: humidity
          };
        });
      })
      .then(function (data) {
        sessionStorage.setItem(cacheKey, JSON.stringify(data));
        initWeather(data);
      })
      .catch(function () {
        if (!weatherData) {
          initWeather({ city: 'your area', region: '', countryCode: '', humidity: 50, fallback: true });
        }
      });
  }

  function getTier(humidity) {
    if (humidity < 45) return 'low';
    if (humidity < 65) return 'moderate';
    return 'high';
  }

  function replaceTokens(text, data, tierConfig) {
    if (!text) return '';
    return text
      .replace(/\{humidity\}/g, Math.round(data.humidity))
      .replace(/\{city\}/g, data.city)
      .replace(/\{tier_label\}/g, tierConfig.tierLabel || '');
  }

  function getDropletIconSvg() {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0L12 2.69z"/>' +
      '</svg>'
    );
  }

  function getTierIconSvg(tier) {
    var icons = {
      low:
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path fill="currentColor" d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"/>' +
        '<g stroke="currentColor" stroke-width="1.7" stroke-linecap="round" fill="none">' +
        '<line x1="7" y1="18.5" x2="17" y2="18.5"/>' +
        '<line x1="8.5" y1="21" x2="15.5" y2="21"/>' +
        '</g></svg>',
      moderate:
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<circle cx="17" cy="7" r="2.4" fill="currentColor"/>' +
        '<g stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none">' +
        '<line x1="17" y1="2.8" x2="17" y2="4"/>' +
        '<line x1="20.5" y1="7" x2="21.7" y2="7"/>' +
        '<line x1="19.6" y1="4.4" x2="20.5" y2="3.5"/>' +
        '</g>' +
        '<path fill="currentColor" d="M18.9 11.2A6.5 6.5 0 0 0 12 6.5c-2.5 0-4.7 1.4-5.8 3.5A5.2 5.2 0 0 0 1.5 15c0 2.9 2.3 5.2 5.2 5.2h11.3c2.4 0 4.3-1.9 4.3-4.3 0-2.2-1.7-4.1-3.9-4.7z"/>' +
        '</svg>',
      high:
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path fill="currentColor" d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"/>' +
        '<g stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none">' +
        '<path d="M7.5 17.2c.7 1 .7 2 0 3"/>' +
        '<path d="M12 16.6c.7 1 .7 2 0 3"/>' +
        '<path d="M16.5 17.2c.7 1 .7 2 0 3"/>' +
        '</g></svg>'
    };
    return icons[tier] || icons.moderate;
  }

  function applyBarTheme(tierConfig) {
    var bg = bar.querySelector('[data-humidity-bar-bg]');

    bar.classList.remove('gk-humidity-bar--low', 'gk-humidity-bar--moderate', 'gk-humidity-bar--high');
    if (currentTier) {
      bar.classList.add('gk-humidity-bar--' + currentTier);
    }

    if (!bg) return;

    if (tierConfig.bannerImage) {
      bg.style.backgroundImage = 'url(' + JSON.stringify(tierConfig.bannerImage) + ')';
    } else {
      bg.style.backgroundImage = 'none';
    }
  }

  function getCityName(data) {
    var city = data && data.city ? String(data.city).trim() : '';
    return city || 'your area';
  }

  function setLocationLabel(data) {
    var cityName = getCityName(data).toUpperCase();

    bar.querySelectorAll('[data-humidity-city], .gk-humidity-bar__city').forEach(function (el) {
      el.textContent = cityName;
    });

    bar.querySelectorAll('[data-humidity-place]').forEach(function (el) {
      el.textContent = 'in ' + getCityName(data);
    });
  }

  function initWeather(data) {
    if (!data || isBarDismissed()) return;

    weatherData = data;
    currentTier = getTier(Math.round(data.humidity));
    var tierConfig = config.tiers[currentTier];
    if (!tierConfig) return;

    var humidityRounded = Math.round(data.humidity);
    bar.removeAttribute('hidden');
    bar.style.display = '';
    bar.style.visibility = '';

    bar.style.setProperty('--gk-humidity-accent', tierConfig.bannerAccent);
    popup.style.setProperty('--gk-humidity-accent', tierConfig.bannerAccent);
    applyBarTheme(tierConfig);

    var forecastIcon = bar.querySelector('[data-humidity-icon]');
    if (forecastIcon) forecastIcon.innerHTML = getDropletIconSvg();

    var riskIcon = bar.querySelector('[data-humidity-risk-icon]');
    if (riskIcon) riskIcon.innerHTML = getTierIconSvg(currentTier);

    var humidityEl = bar.querySelector('[data-humidity-value]');
    if (humidityEl) humidityEl.textContent = humidityRounded;

    setLocationLabel(data);

    bar.querySelector('[data-humidity-headline]').textContent = replaceTokens(
      tierConfig.bannerHeadline,
      data,
      tierConfig
    );
    bar.querySelector('[data-humidity-desc]').textContent = replaceTokens(
      tierConfig.bannerDescription,
      data,
      tierConfig
    );
    var btnLabel = bar.querySelector('[data-open-popup-label]');
    if (btnLabel) {
      btnLabel.textContent = tierConfig.buttonText || 'See my humidity plan';
    }

    bar.classList.add('is-visible');
  }

  function openPopup() {
    if (!weatherData || !currentTier) return;

    var tierConfig = config.tiers[currentTier];
    var header = popup.querySelector('[data-popup-header]');
    header.style.background = tierConfig.popupHeader;

    popup.querySelector('[data-popup-meta]').innerHTML =
      '<span class="gk-humidity-popup__header-meta-icon">' +
      getTierIconSvg(currentTier) +
      '</span> Today in ' +
      weatherData.city +
      ' · ' +
      Math.round(weatherData.humidity) +
      '% humidity · ' +
      tierConfig.tierLabel;
    popup.querySelector('[data-popup-title]').textContent = replaceTokens(
      tierConfig.popupTitle,
      weatherData,
      tierConfig
    );
    popup.querySelector('[data-popup-text]').textContent = replaceTokens(
      tierConfig.popupDescription,
      weatherData,
      tierConfig
    );
    popup.querySelector('[data-popup-footer-text]').textContent = replaceTokens(
      tierConfig.footerText,
      weatherData,
      tierConfig
    );
    popup.querySelector('[data-add-all]').textContent = config.addAllText;

    renderProducts(tierConfig);

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gk-humidity-popup-open');
  }

  function getVariant(productIndex, variantId) {
    var product = config.products[productIndex];
    if (!product) return null;
    var id = parseInt(variantId, 10);
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return null;
  }

  function formatMoney(cents) {
    var format = config.moneyFormat;
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(
        cents,
        (theme.settings && theme.settings.moneyFormat) || format
      );
    }

    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatWithDelimiters(cents, 2);

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function formatProductPrice(variant, product) {
    var cents = variant ? variant.price : product.priceMin;
    return formatMoney(cents);
  }

  function setProductPrice(el, variant, product) {
    if (!el) return;
    el.innerHTML = formatProductPrice(variant, product);
  }

  function updateRowPrice(row) {
    var productIndex = parseInt(row.dataset.productIndex, 10);
    var product = config.products[productIndex];
    var select = row.querySelector('[data-variant-select]');
    var priceEl = row.querySelector('[data-product-price]');
    if (!product || !select || !priceEl) return;

    var variant = getVariant(productIndex, select.value);
    setProductPrice(priceEl, variant, product);
  }

  function bindVariantSelects(container) {
    container.querySelectorAll('[data-variant-select]').forEach(function (select) {
      if (select.tagName !== 'SELECT') return;
      select.addEventListener('change', function () {
        updateRowPrice(select.closest('.gk-humidity-popup__product'));
      });
    });
  }

  function renderProducts(tierConfig) {
    var container = popup.querySelector('[data-popup-products]');
    container.innerHTML = '';

    if (!config.products || !config.products.length) {
      container.innerHTML = '<p style="padding:1.5rem;color:#666;">Add products to the article four_products metafield.</p>';
      popup.querySelector('[data-add-all]').disabled = true;
      return;
    }

    popup.querySelector('[data-add-all]').disabled = false;

    config.products.forEach(function (product, index) {
      var stepLabel = config.stepLabels[index] || 'Step ' + (index + 1);
      var desc = tierConfig.stepDescriptions[index] || '';
      var availableVariants = product.variants.filter(function (v) { return v.available; });
      var defaultVariant = availableVariants[0] || product.variants[0];

      var row = document.createElement('div');
      row.className = 'gk-humidity-popup__product';
      row.dataset.productIndex = index;

      var isMultiVariant = !product.hasOnlyDefaultVariant && product.variants.length > 1;

      var variantHtml = '';
      if (isMultiVariant) {
        variantHtml = '<select class="gk-humidity-popup__variant-select" data-variant-select>';
        product.variants.forEach(function (variant) {
          variantHtml +=
            '<option value="' +
            variant.id +
            '"' +
            (variant.id === defaultVariant.id ? ' selected' : '') +
            (variant.available ? '' : ' disabled') +
            '>' +
            variant.title +
            (variant.available ? '' : ' — Sold out') +
            '</option>';
        });
        variantHtml += '</select>';
      } else {
        variantHtml =
          '<input type="hidden" data-variant-select value="' +
          (defaultVariant ? defaultVariant.id : '') +
          '">';
      }

      row.innerHTML =
        '<div class="gk-humidity-popup__step">' +
        (index + 1) +
        '</div>' +
        '<a class="gk-humidity-popup__product-image" href="' +
        product.url +
        '" target="_blank" rel="noopener noreferrer"><img src="' +
        product.image +
        '" alt="' +
        escapeHtml(product.title) +
        '"></a>' +
        '<div class="gk-humidity-popup__product-body">' +
        '<div class="gk-humidity-popup__product-top">' +
        '<a class="gk-humidity-popup__product-title" href="' +
        product.url +
        '" target="_blank" rel="noopener noreferrer">' +
        stepLabel +
        ' — ' +
        escapeHtml(product.title) +
        '</a>' +
        '<p class="gk-humidity-popup__product-price" data-product-price></p>' +
        '</div>' +
        '<p class="gk-humidity-popup__product-desc">' +
        escapeHtml(desc) +
        '</p>' +
        variantHtml +
        '</div>';

      container.appendChild(row);
      setProductPrice(
        row.querySelector('[data-product-price]'),
        defaultVariant,
        product
      );
    });

    bindVariantSelects(container);
  }

  function closePopup() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gk-humidity-popup-open');
  }

  function addAllToCart() {
    var items = [];
    popup.querySelectorAll('[data-popup-products] .gk-humidity-popup__product').forEach(function (row) {
      var select = row.querySelector('[data-variant-select]');
      if (!select || !select.value) return;
      items.push({ id: parseInt(select.value, 10), quantity: 1 });
    });

    if (!items.length) return;

    var btn = popup.querySelector('[data-add-all]');
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch(window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422) throw new Error(data.description || 'Could not add to cart');
        btn.textContent = 'Added!';
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
        window.setTimeout(function () {
          closePopup();
          btn.textContent = config.addAllText;
          btn.disabled = false;
        }, 900);
      })
      .catch(function () {
        btn.textContent = config.addAllText;
        btn.disabled = false;
      });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function bindEvents() {
    bar.querySelector('[data-open-popup]').addEventListener('click', openPopup);

    var dismissBtn = bar.querySelector('[data-dismiss-bar]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dismissBar();
      });
    }

    popup.querySelectorAll('[data-close-popup]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    popup.querySelector('[data-add-all]').addEventListener('click', addAllToCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) closePopup();
    });
  }
})();
